'use strict';

import angular from 'angular';
import FileSaveSvc from './fileSave.js';

export default angular.module('georgeApp.filesave', [])
  .factory('FileSaveSvc', FileSaveSvc)
  .name;
